<template>
  <v-dialog v-model="updateDialog" max-width="700" persistent>
    <v-card :loading="loading" loader-height="2">
      <v-card-title>update subsidiary service</v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="add.medicinesid"
          :items="pharmacatlist"
          dense
          item-text="name"
          item-value="id"
          label="medicine category"
        ></v-autocomplete>

        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="add.brand_name"
              label="brand name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="add.brand_description"
              label="description"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="add.manufacturer"
              dense
              label="manufacturer"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="add.bar_code"
              dense
              label="barcode"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6">
            <v-row>
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="add.weight"
                  dense
                  label="weight"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="add.weight_measurements_id"
                  :items="myMasslist"
                  dense
                  item-text="shortcut"
                  item-value="id"
                  label="measure"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6">
            <v-row>
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="add.volume"
                  dense
                  label="volume"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="add.volume_measurements_id"
                  :items="myVolumelist"
                  dense
                  item-text="shortcut"
                  item-value="id"
                  label="volume"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="add.stock"
              dense
              label="stock"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="auto"
              offset-y
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="add.expiry"
                  dense
                  label="Expiry date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="add.expiry"
                :min="today"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="red" small text @click="closeDialog" v-on="on">
              cancel
            </v-btn>
          </template>
          <span>cancel</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              :disabled="$v.add.$invalid"
              color="blue"
              small
              text
              @click="submit"
              v-on="on"
            >
              submit
            </v-btn>
          </template>
          <span>Submit</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Restful from "@/services/RestFul";
import moment from "moment";
import Utils from "../../mixins/utils";
import Measurements from "../../mixins/measurements";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [Measurements, Utils, validationMixin],
  props: {
    updateDialog: Boolean,
    myId: { trype: Number },
  },
  data() {
    return {
      loading: false,
      pharmacatlist: [],
      today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu2: null,
      add: {
        subscriber_subsidiariesid: this.myId,
        brand_name: null,
        manufacturer: null,
        medicinesid: null,
        brand_description: null,
        bar_code: null,
        weight: 0,
        weight_measurements_id: 4,
        volume: 0,
        volume_measurements_id: 3,
        stock: 1,
        expiry: null,
      },
    };
  },
  validations: {
    add: {
      medicinesid: {
        required,
      },
      brand_name: {
        required,
      },
      brand_description: { required },
      stock: { required },
      expiry: { required },
    },
  },
  created() {
    this.find();
    this.pharmacat();
  },
  methods: {
    pharmacat() {
      this.loading = true;
      let self = this;
      Restful.general.medicines
        .list()
        .then((response) => {
          console.log(response.data);
          this.pharmacatlist = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error.response);
          self.loading = false;
        });
    },
    find() {
      this.loading = true;
      let self = this;
      Restful.subscribers.pharma_stocks
        .find(this.myId)
        .then((response) => {
          console.log(response.data);
          this.add.brand_name = response.data.brand_name;
          this.add.medicinesid = response.data.medicinesid;
          this.add.brand_description = response.data.brand_description;
          this.add.bar_code = response.data.bar_code;
          this.add.weight = response.data.weight;
          this.add.manufacturer = response.data.manufacturer;
          this.add.weight_measurements_id =
            response.data.weight_measurements_id;
          this.add.volume = response.data.volume;
          this.add.volume_measurements_id =
            response.data.volume_measurements_id;
          this.add.price = response.data.price;
          this.add.stock = response.data.stock;
          this.add.expiry = moment(response.data.expire).format("yyyy-MM-DD"); // response.data.expire;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error.response);
          self.loading = false;
        });
    },
    closeDialog() {
      let payload = { id: this.myId, state: false };
      this.$emit("closeUpdate", payload);
    },
    submit() {
      let medicinesid = this.add.medicinesid;
      let brand_name = this.add.brand_name;
      let brand_description = this.add.brand_description;
      let bar_code = this.add.bar_code;
      let weight = parseInt(this.add.weight);
      let weight_measurements_id = this.add.weight_measurements_id;
      let volume = parseInt(this.add.volume);
      let volume_measurements_id = this.add.volume_measurements_id;
      let stock = parseInt(this.add.stock);
      let expiry = Date.parse(this.add.expiry);
      let manufacturer = this.add.manufacturer;

      let data = {
        manufacturer,
        medicinesid,
        brand_name,
        brand_description,
        bar_code,
        weight,
        weight_measurements_id,
        volume,
        volume_measurements_id,
        stock,
        expiry,
      };
      console.log("data:", data);
      let payload = { id: this.myId, data: data, state: false };
      this.$emit("submitUpdate", payload);
    },
  },
};
</script>
